import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Products.css";
import SEO from "../components/SEO.js";
const categories = [
  {
    name: "White Imported Marble",
    slug: "/white-imported-marble",
    image: "/marble-type/michael-angelo-white/michael-angelo-white-lot.webp",
    description:
      "Premium white imported & Italian marble known for elegance, purity and timeless luxury. Ideal for villas, hotels and high-end interiors across India.",
  },
  {
    name: "Exotic Imported Marble",
    slug: "/exotic-imported-marble",
    image: "/marble-type/avocado/avocado-lot.webp",
    description:
      "Rare exotic & highlighter imported marble slabs featuring dramatic patterns and bold aesthetics for statement luxury spaces.",
  },
  {
    name: "Grey Imported Marble",
    slug: "/gray-imported-marble",
    image: "/marble-type/gray-temptation/gray-temptation-lot.webp",
    description:
      "Sophisticated grey imported marble offering a modern, minimal and architectural appeal for premium residential and commercial projects.",
  },
  {
    name: "Beige Imported Marble",
    slug: "/beige-imported-marble",
    image: "/marble-type/brescia/brescia-lot.webp",
    description:
      "Warm beige imported marble with natural textures, perfect for classic interiors, luxury flooring and timeless Italian design.",
  },
];

const Products = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Imported & Italian Marble Collections | White, Grey, Beige & Exotic Marble – Square Feet Marble Kishangarh  "
        description="Explore premium imported & Italian marble categories at Square Feet Marble, Kishangarh. Discover White, Grey, Beige and Exotic marble collections for luxury homes and projects."
        keywords="imported marble categories, italian marble collection, white imported marble, exotic marble india, grey italian marble, beige imported marble"
        canonical="https://www.squarefeetmarble.com/exotic-imported-marble-kishangarh.webp"
      />

      <div className="products-page-container">
        <header className="products-header">
          <h1 className="main-heading">
            Imported & Italian Marble Collections
          </h1>
          <p className="subheading">
<span className="highlight">Our Imported and Italian Marble collections</span> represent the finest selection of natural stones sourced from globally renowned quarries. <span className="highlight">Carefully curated for discerning homeowners, architects, and interior designers, </span>these marbles are known for their timeless elegance, superior durability, and luxurious appeal.

From classic Italian marbles like Statuario, Carrara, and Botticino to premium imported varieties from Europe and beyond, each slab reflects exceptional craftsmanship and natural beauty. These marbles are ideal for luxury homes, villas, hotels, commercial projects, and premium lifestyle spaces across India.

Whether you’re designing a modern interior or a grand architectural space, <span className="highlight">Our Imported and Italian Marble collections in India</span> offer a perfect balance of aesthetics and performance—making every space refined, elegant, and enduring.
          </p>
        </header>

        <section className="category-grid">
          {categories.map((cat) => (
            <div
              key={cat.slug}
              className="category-card"
              onClick={() => navigate(cat.slug)}
              role="button"
              aria-label={`View ${cat.name}`}
            >
              <img
                src={cat.image}
                alt={`${cat.name} in Kishangarh India`}
                loading="lazy"
              />
              <div className="category-content">
                <h2>{cat.name}</h2>
                <p>{cat.description}</p>
                <span className="explore-btn">Explore Collection →</span>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  );
};

export default Products;
